export const SET_NAVIGATIONS = 'SET_NAVIGATIONS';
export const SET_NAVIGATION = 'SET_NAVIGATION';
export const ADD_NAVIGATION = 'ADD_NAVIGATION';
export const UPDATE_NAVIGATION = 'UPDATE_NAVIGATION';
export const REMOVE_NAVIGATION = 'REMOVE_NAVIGATION';
export const CLEAR_NAVIGATION = 'CLEAR_NAVIGATION';
export const CLEAR_NAVIGATIONS = 'CLEAR_NAVIGATIONS';
